import type { SVGProps } from 'react'
const SvgSySecure = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={24} height={24} {...props}>
		<path d="M36.2 31.3c0-7.6 6.2-13.8 13.8-13.8s13.8 6.2 13.8 13.8v3.4c1.4.7 2.7 1.6 3.9 2.5v-6c0-9.8-7.9-17.7-17.7-17.7s-17.7 7.9-17.7 17.7v6c1.2-.9 2.5-1.8 3.9-2.5z" />
		<path d="M72.1 48 50.8 69.9c-.4.4-1.1.4-1.5 0L37.2 55.7c-.3-.4-.3-1 0-1.3l2.4-2.4c.3-.3.8-.4 1.2-.2l9.2 5.1 18.2-14c-4.6-4.7-11.1-7.6-18.2-7.6-14.1 0-25.6 11.5-25.6 25.6S35.9 86.5 50 86.5 75.6 75 75.6 60.9s-1.3-9.1-3.5-12.8z" />
	</svg>
)
export default SvgSySecure
